import type { BattleInfo } from "../shared-sortaballs/PuzzleHeader"
import type { SortaballsVariantConfig } from "./sortaballs-variant"

import { sortaballs10ColorsLevelStore } from "./level-store"
import { isSolvedWithinMoves, SA_CAPACITY } from "./logic"
import { checkIfSolved, saveProgress } from "./puzzle-progress"
import { getPuzzleById, getTotalPuzzleCount, usePuzzlesReady, warmPuzzles } from "./puzzles"
import { SortaballsGame } from "./SortaballsGame"

const NEAR_WIN_MOVES = 3

const SORTABALLS_VARIANT_CONFIG: SortaballsVariantConfig = {
  advanced: true,
  capacity: SA_CAPACITY,
  helpMoveCount: "revealed",
  levelStore: sortaballs10ColorsLevelStore,
  nearWin: (board)=> isSolvedWithinMoves(board, SA_CAPACITY, NEAR_WIN_MOVES),
  progress: { checkIfSolved, saveProgress },
  puzzles: {
    getPuzzleById,
    getTotalPuzzleCount,
    useReady: usePuzzlesReady,
    warm: warmPuzzles,
  },
  title: "Sortaballs",
}

export function Sortaballs10ColorsApp(
  input: { advancedBy?: number; battle?: BattleInfo; hideHints?: boolean } = {},
) {
  return <SortaballsGame config={SORTABALLS_VARIANT_CONFIG} {...input} />
}